import React from 'react';
import Spinner from './Spinner';

const SimpleButton = ({ showLoader, text, icon, onClick, extraClasses, ariaLabel = '' }) => {
  return (
    <button
      type={'button'}
      onClick={onClick}
      className={`${extraClasses} btn cursor-pointer`}
      {...(ariaLabel !== '' ? { 'aria-label': ariaLabel } : {})}
    >
      <span className='flex items-center'>
        <span>{text}</span>
        {icon && (
          <span
            className={icon.classes}
            dangerouslySetInnerHTML={{ __html: icon.svg }}
          />
        )}
      </span>
      {showLoader && (
        <div className='mb-1 results-loader'>
          <Spinner modifierClasses='lds-ellipsis--white' />
        </div>
      )}
    </button>
  );
};

export default SimpleButton;
